import { Injectable, ɵsetAllowDuplicateNgModuleIdsForTest } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

import OneSignal from 'onesignal-cordova-plugin';

const TOKEN_KEY = 'AuthToken';
const JWT_KEY = 'jwt_token';
const USERNAME_KEY = 'AuthUsername';
const AUTHORITIES_KEY = 'AuthAuthorities';
const USERCLUB_KEY = 'Club';
const USERACTIVO_KEY = 'Activo';



@Injectable({
  providedIn: 'root'
})
export class TokenService {


  private apiUrl = environment.apiUrl; // URL del backend para registrar notificaciones
  constructor(
    private storage: Storage,
    private http: HttpClient
  ) { }

  ngOnInit() { }

  // public setToken(token: string): void {
  //   window.sessionStorage.removeItem(TOKEN_KEY);
  //   window.sessionStorage.setItem(TOKEN_KEY, token);
  // }

  // public getToken(): string {
  //   return window.sessionStorage.getItem(TOKEN_KEY);
  // }

  // public setUsername(userName: string): void {
  //   window.sessionStorage.removeItem(USERNAME_KEY);
  //   window.sessionStorage.setItem(USERNAME_KEY, userName);
  // }

  // public getUserName(): string{
  //   return window.sessionStorage.getItem(USERNAME_KEY);
  // }

  // public setClub(userClub: string): void {
  //   window.sessionStorage.removeItem(USERCLUB_KEY);
  //   window.sessionStorage.setItem(USERCLUB_KEY, userClub);
  // }

  // public getClub(): string{
  //   return window.sessionStorage.getItem(USERCLUB_KEY);
  // }

  // public setActivo(userActivo: string): void {
  //   window.sessionStorage.removeItem(USERACTIVO_KEY);
  //   window.sessionStorage.setItem(USERACTIVO_KEY, userActivo);
  // }

  // public getActivo(): string{
  //   return window.sessionStorage.getItem(USERACTIVO_KEY);
  // }

  // public setAuthorities(authorities: string[]): void{
  //   window.sessionStorage.removeItem(AUTHORITIES_KEY);
  //   window.sessionStorage.setItem(AUTHORITIES_KEY, JSON.stringify(authorities));
  // }

  // public getAuthorities(): string[]{
  //   const roles: string[] = [];
  //   if(sessionStorage.getItem(AUTHORITIES_KEY)){
  //     JSON.parse(sessionStorage.getItem(AUTHORITIES_KEY)).forEach(rol =>{
  //       roles.push(rol);
  //     });
  //   }
  //   return roles;
  // }

  // public logOut(): void{
  //   window.sessionStorage.clear();
  //   this.storage.clear();
  // }

  public setToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(JWT_KEY, token);
    // En plataformas nativas persistir en Preferences (Keychain / SharedPreferences)
    Preferences.set({ key: JWT_KEY, value: token }).catch(err => {
      console.warn('Error al guardar token en Preferences:', err);
    });
    Preferences.set({ key: TOKEN_KEY, value: token }).catch(() => {});
  }

  public getToken(): string {
    return localStorage.getItem(JWT_KEY) || localStorage.getItem(TOKEN_KEY);
  }

  public async getSecureToken(): Promise<string | null> {
    try {
      const { value } = await Preferences.get({ key: JWT_KEY });
      return value || this.getToken();
    } catch {
      return this.getToken();
    }
  }

  public isTokenExpired(token?: string): boolean {
    const jwt = token || this.getToken();
    if (!jwt) {
      return true;
    }
    try {
      const parts = jwt.split('.');
      if (parts.length !== 3) {
        return true;
      }
      const payload = JSON.parse(atob(parts[1]));
      if (!payload.exp) {
        return false; // Si no tiene exp explícito, se considera vigente
      }
      const expirationDate = new Date(payload.exp * 1000);
      return expirationDate.getTime() <= Date.now();
    } catch {
      return true;
    }
  }

  public hasValidToken(): boolean {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  public setUsername(userName: string): void {
    localStorage.removeItem(USERNAME_KEY);
    localStorage.setItem(USERNAME_KEY, userName);
  }

  public getUserName(): string {
    return localStorage.getItem(USERNAME_KEY);
  }

  public setClub(userClub: string): void {
    localStorage.removeItem(USERCLUB_KEY);
    localStorage.setItem(USERCLUB_KEY, userClub);
  }

  public getClub(): string {
    return localStorage.getItem(USERCLUB_KEY);
  }

  public setActivo(userActivo: string): void {
    localStorage.removeItem(USERACTIVO_KEY);
    localStorage.setItem(USERACTIVO_KEY, userActivo);
  }

  public getActivo(): string {
    return localStorage.getItem(USERACTIVO_KEY);
  }

  public setAuthorities(authorities: string[]): void {
    localStorage.removeItem(AUTHORITIES_KEY);
    localStorage.setItem(AUTHORITIES_KEY, JSON.stringify(authorities));
  }

  public getAuthorities(): string[] {
    const roles: string[] = [];
    if (localStorage.getItem(AUTHORITIES_KEY)) {
      JSON.parse(localStorage.getItem(AUTHORITIES_KEY)).forEach(rol => {
        roles.push(rol);
      });
    }
    return roles;
  }

  public setClienteDatos(datos: any): void {
    const json = typeof datos === 'string' ? datos : JSON.stringify(datos);
    sessionStorage.setItem('datos', json);
    localStorage.setItem('datos', json);
  }

  public getClienteDatos(): any {
    const raw = sessionStorage.getItem('datos') || localStorage.getItem('datos');
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  public async logOut(): Promise<boolean> {
    let exito = false;
    // Verificar si se ha inicializado OneSignal
    // Si no se ha inicializado, no intentamos cerrar sesión
    // 'loginnoti', 'true' buscamos en el local storage
    // Si se ha inicializado, cerramos sesión en OneSignal
    // Sacar OneSignal

    // DESCOMENTAR
    try {
      if (Capacitor.isNativePlatform()) {
        OneSignal.logout();
        const idodooString = localStorage.getItem('IDusuario') || '0'; // ID del usuario de Odoo
        const idodoo = parseInt(idodooString, 10); // Convertir a número
        // Mandar a llamar el endpoint para hacer el logout
        const respuesta = await this.http.put<string>(`${this.apiUrl}usuarios/notificaciones/cerrarSesion/${idodoo}`, {}).toPromise();
        const respuestaTags = await this.http.put(`${this.apiUrl}tags/inactivotags/${idodoo}`, {},
          { responseType: 'text' }).toPromise();
        console.log("Respuesta del servidor al cerrar sesión:", respuesta);
        console.log("Respuesta del servidor al inactivar tags:", respuestaTags);
        if (respuesta) {
          console.log("Usuario deslogueado de las notificaciones.");
        }
        if (respuestaTags) {
          console.log("Tags false");
        }
        exito = !!respuesta && !!respuestaTags;
      } else {
        console.warn("OneSignal logout is only available on native platforms.");
      }
      console.log("Usuario deslogueado de ONESIGNAL.");
    } catch (error) {
      console.error("Error al cerrar sesión en OneSignal:", error);
      exito = false;
    }

    // Eliminar el loginnoti del localStorage
    localStorage.removeItem('loginnoti');
    console.log("Usuario deslogueado de las notificaciones.");
    try {
      await Preferences.remove({ key: JWT_KEY });
      await Preferences.remove({ key: TOKEN_KEY });
    } catch (e) {
      console.warn('Error al limpiar Preferences en logOut:', e);
    }
    localStorage.clear();
    sessionStorage.clear();
    this.storage.clear();
    // Eliminar el OneSignal ID del usuario
    console.log("Eliminando OneSignal ID del usuario.");
    return exito;
  }
}
